import { getMonthToDateRange } from '@/utils/date';
import {
  ACTIVE_STATUS_CHOICES,
  parseEnumFilter,
  parseNumberFilter,
  toFilterText,
  toPeriodFilterValues,
  toPeriodSearch,
} from '@/utils/filters';
import { ZM_STATUS_FILTER_KEY } from '../constants/dashboard.constants';
import type { SystemDashboardListSearch, SystemDashboardSearch } from '../types/dashboard.types';

export const REPORTING_MEMBER_FILTER_KEY = 'amUserId';

export function toReportingPeriodFilterValues(
  search: SystemDashboardSearch,
): Record<string, string> {
  return {
    ...toPeriodFilterValues(search, getMonthToDateRange()),
    [ZM_STATUS_FILTER_KEY]: toFilterText(search.zmStatus),
    [REPORTING_MEMBER_FILTER_KEY]: toFilterText(search.amUserId),
  };
}

export function toReportingPeriodFilterSearch(
  values: Record<string, string>,
): SystemDashboardSearch {
  return {
    ...toPeriodSearch(values),
    zmStatus: parseEnumFilter(values[ZM_STATUS_FILTER_KEY], ACTIVE_STATUS_CHOICES),
    amUserId: parseNumberFilter(values[REPORTING_MEMBER_FILTER_KEY]),
  };
}

export function toSystemDrillSearch({
  search: _search,
  ...drillSearch
}: SystemDashboardListSearch): SystemDashboardSearch {
  return drillSearch;
}
